var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBarDesktop'),_c('main',{attrs:{"id":"main-template"}},[_vm._t("default")],2),_c('UberFooter'),_c('innovative-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }